import { Button } from '@chakra-ui/react'
import { generatePath, Link } from 'react-router'
import { Paths } from 'src/constants/paths'
import { useSelectedTrial } from 'src/features/auth/context'

type Props = {
  referredPatientUid: string
}

export const CreateExplanationButton: React.FC<Props> = ({
  referredPatientUid,
}) => {
  const { selectedTrial } = useSelectedTrial()

  return (
    <Button
      as={Link}
      to={{
        pathname: generatePath(Paths.ExplanationsNew, {
          trialUid: selectedTrial.uid,
        }),
        search: `referredPatientUid=${referredPatientUid}`,
      }}
    >
      同意説明登録
    </Button>
  )
}
